import { Injectable, inject } from '@angular/core';
import { NgrxHttpClient } from '@library/utils/services/http-service';
import {
  ChangePolarityPayload,
  ModuleRoomUpdate,
  RemoveDataGatewayPayload,
  RemoveModulePayload,
  TransferMeasurementsPayload,
} from './modules.interface';

@Injectable()
export class ModulesService {
  protected http = inject(NgrxHttpClient);

  changePolarity(params: ChangePolarityPayload) {
    return this.http.post('changedevicebehavior', params);
  }

  updateModule(params, header?: Record<string, string>) {
    return this.http.post('updatemodule', params, null, null, header);
  }

  updateDevice(params) {
    return this.http.post('updatedevice', params);
  }

  updateModuleRoom(params: ModuleRoomUpdate, header?: Record<string, string>) {
    return this.http.post('assigndevicetoroom', params, null, null, header);
  }

  removeDeviceFromHome(params: RemoveModulePayload) {
    return this.http.post('removedevicefromhome', params);
  }

  removeDataGateway(params: RemoveDataGatewayPayload) {
    return this.http.post('removedata', params);
  }

  transferModuleMeasurements(params: TransferMeasurementsPayload) {
    return this.http.post('transfermeasurements', params);
  }
}
